import { createSlice } from "@reduxjs/toolkit";

const balanceSlice = createSlice({
  name: "balanceSlice",
  initialState: {
    travaBalance: undefined,
    rTravaBalance: undefined,
  },
  reducers: {
    updateBalance(state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export default balanceSlice.reducer;
export const { updateBalance } = balanceSlice.actions;
